import React, { useEffect, useState } from "react";
import "./LoanCalculator.css";
import Second_Header from "../Common_Component/Second_Header/Second_Header";
import Btn_With_Img from "../Common_Component/Common_Btn/Btn_With_Img/Btn_With_Img";
import Home_Loan_Lottie from "../animation/Home_Loan_Lottie/Home_Loan_Lottie";
import Personal_Loan_Lottie from "../animation/Personal_Loan_Lottie/Personal_Loan_Lottie";
import All_Scales_Component from "./All_Scales_Component/All_Scales_Component";
import CompareLoanComponent from "./CompareLoanComponent/CompareLoanComponent";
import TotalPaymentBreakup from "./TotalPaymentBreakup/TotalPaymentBreakup";
import BarChartComponent from "./BarChartComponent/BarChartComponent";
import All_Scales_Component_personal from "./All_Scales_Component/All_Scales_Component_personal";
import Cookies from "js-cookie";
const LoanCalculator = () => {
  const [activeBtn, setActiveBtn] = useState("home_loan");

  const [loanValueTotal, setLoanValueTotal] = useState(100);
  const [principalTotal, setprincipalTotal] = useState(100);
  const [EMITotal, setEMITotal] = useState(30);
  const [interestTotal, setInterestTotal] = useState(20);

  const [yearlyBreakdown, setYearlyBreakdown] = useState([]);

  //   const [loanValue, setLoanValue] = useState(activeBtn === "home_loan" ? 100 : 15);
  //   const [interestRate, setInterestRate] = useState(activeBtn === "home_loan" ? 20 : 30);
  //   const [loanTenure, setLoanTenure] = useState(activeBtn === "home_loan" ? 240 : 36);

  const [loanValue, setLoanValue] = useState(100);
  const [interestRate, setInterestRate] = useState(20);
  const [loanTenure, setLoanTenure] = useState(240);

  useEffect(() => {
    if (activeBtn === "home_loan") {
      setLoanValue(100);
      setInterestRate(20);
      setLoanTenure(240);
    } else {
      setLoanValue(5);
      setInterestRate(20);
      setLoanTenure(36);
    }
  }, [activeBtn]);

  const [date, setDate] = useState(); // Ensure correct format

  console.log(yearlyBreakdown, "yearlyBreakdown yearlyBreakdown");

  const [data, setData] = useState();
  const user_data = Cookies.get("user_data"); // Get the value of 'status' cookie

  useEffect(() => {
    if (user_data) {
      const parsedData = JSON.parse(user_data);
      setData(parsedData);
    }
  }, [user_data]);
  return (
    <>
    {data && <Second_Header setData={setData} data={data} showCompare={false} showFilter={false} />}
      
      <section className="LoanCalculator">
        {/* <div className='second_h_holder'>
                <Second_Header showCompare={false} showFilter={false} />
            </div> */}

        <div className="container">
          <div className="tab_buttons_div">
            <div className="home_loan_btn_div">
              <Btn_With_Img
                lottie={Home_Loan_Lottie}
                className={activeBtn === "home_loan" ? "active" : ""}
                btn_name="Home Loan"
                onClick={() => {
                  setActiveBtn("home_loan");
                }}
              />
            </div>

            <div className="personal_loan_btn_div">
              <Btn_With_Img
                lottie={Personal_Loan_Lottie}
                className={activeBtn === "personal_loan" ? "active" : ""}
                btn_name="Personal Loan"
                onClick={() => {
                  setActiveBtn("personal_loan");
                }}
              />
            </div>
          </div>

          {activeBtn === "home_loan" && (
            <>
              <div className="all_scales_main_div">
                <All_Scales_Component
                  loanValueTotal={loanValueTotal}
                  setLoanValueTotal={setLoanValueTotal}
                  interestTotal={interestTotal}
                  setInterestTotal={setInterestTotal}
                  EMITotal={EMITotal}
                  setEMITotal={setEMITotal}
                  principalTotal={principalTotal}
                  setprincipalTotal={setprincipalTotal}
                  setLoanTenure={setLoanTenure}
                  loanTenure={loanTenure}
                  setInterestRate={setInterestRate}
                  interestRate={interestRate}
                  setLoanValue={setLoanValue}
                  loanValue={loanValue}
                  setYearlyBreakdown={setYearlyBreakdown}
                  date={date}
                  yearlyBreakdown={yearlyBreakdown}
                />
              </div>

              <div className="total_payment_breakup_div">
                <TotalPaymentBreakup
                  loanValueTotal={loanValueTotal}
                  interestTotal={interestTotal}
                  EMITotal={EMITotal}
                  principalTotal={principalTotal}
                />
              </div>

              <div className="compare_loan_div">
                <CompareLoanComponent
                  loanValueTotal={loanValueTotal}
                  interestTotal={interestTotal}
                  EMITotal={EMITotal}
                  date={date}
                  setDate={setDate}
                />
              </div>

              <div className="bar_chart_div">
                <BarChartComponent
                  loanValueTotal={loanValueTotal}
                  interestTotal={interestTotal}
                  EMITotal={EMITotal}
                  principalTotal={principalTotal}
                  date={date}
                  loanTenure={loanTenure}
                  loanValue={loanValue}
                  interestRate={interestRate}
                  yearlyBreakdown={yearlyBreakdown}
                />
              </div>
            </>
          )}

          {activeBtn === "personal_loan" && (
            <>
              <div className="all_scales_main_div">
                <All_Scales_Component_personal
                  loanValueTotal={loanValueTotal}
                  setLoanValueTotal={setLoanValueTotal}
                  interestTotal={interestTotal}
                  setInterestTotal={setInterestTotal}
                  EMITotal={EMITotal}
                  setEMITotal={setEMITotal}
                  principalTotal={principalTotal}
                  setprincipalTotal={setprincipalTotal}
                  setLoanTenure={setLoanTenure}
                  loanTenure={loanTenure}
                  setInterestRate={setInterestRate}
                  interestRate={interestRate}
                  setLoanValue={setLoanValue}
                  loanValue={loanValue}
                  setYearlyBreakdown={setYearlyBreakdown}
                  date={date}
                  yearlyBreakdown={yearlyBreakdown}
                />
              </div>

              <div className="total_payment_breakup_div">
                <TotalPaymentBreakup
                  loanValueTotal={loanValueTotal}
                  interestTotal={interestTotal}
                  EMITotal={EMITotal}
                  principalTotal={principalTotal}
                />
              </div>

              <div className="compare_loan_div">
                <CompareLoanComponent
                  loanValueTotal={loanValueTotal}
                  interestTotal={interestTotal}
                  EMITotal={EMITotal}
                  date={date}
                  setDate={setDate}
                />
              </div>

              <div className="bar_chart_div">
                <BarChartComponent
                  loanValueTotal={loanValueTotal}
                  interestTotal={interestTotal}
                  EMITotal={EMITotal}
                  principalTotal={principalTotal}
                  date={date}
                  loanTenure={loanTenure}
                  loanValue={loanValue}
                  interestRate={interestRate}
                  yearlyBreakdown={yearlyBreakdown}
                />
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default LoanCalculator;
